/* AUTO GENERATED CONTENT: DO NOT MODIFY THIS FILE. SEE /TOOLS FOLDER FOR CHANGES */

export const palette = {
  'box-neutral-default': 'inset 0px 0px 0px 1px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-out': '0px 0px 0px 1px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-right-divider': 'inset -1px 0px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-left-divider': 'inset 1px 0px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-bottom-divider': 'inset 0px -1px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-top-divider': 'inset 0px 1px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-y-divider':
    'inset 0px -1px 0px rgba(142, 168, 190, 0.16), inset 0px 1px 0px rgba(142, 168, 190, 0.16)',
  'box-neutral-default-x-divider':
    'inset -1px 0px 0px rgba(142, 168, 190, 0.16), inset 1px 0px 0px rgba(142, 168, 190, 0.16)',
  'shadow-bevel-neutral-default':
    'inset 0 0 0 0.0625rem hsl(207, 25%, 11%, 0.08), inset 0 -0.0625rem 0 0 hsl(207, 25%, 11%, 0.24)',
  'outline-md-neutral-dark-32':
    'inset 0 0 0 0.0625rem hsl(207, 25%, 11%, 0.32), 0 0 0 0.25rem hsl(207, 25%, 11%, 0.08)',
  'outline-md-purple-dark-100':
    'inset 0 0 0 0.0625rem hsl(247, 100%, 62%, 1), 0 0 0 0.25rem hsl(247, 100%, 62%, 0.12)',
  'outline-md-teal-dark-100':
    'inset 0 0 0 0.0625rem hsl(188, 100%, 28%, 1), 0 0 0 0.25rem hsl(188, 100%, 28%, 0.12)',
  'shadow-bevel-neutral-darker':
    'inset 0 0 0 0.0625rem hsl(207, 25%, 11%, 0.12), inset 0 -0.0625rem 0 0 hsl(207, 25%, 11%, 0.24)',
  'inline-xs-neutral-dark-4': 'inset 0 0 0 0.0625rem hsl(207, 25%, 11%, 0.04)',
  'inline-xs-neutral-dark-8': 'inset 0 0 0 0.0625rem hsl(207, 25%, 11%, 0.08)',
  'inline-xs-neutral-dark-16': 'inset 0 0 0 0.0625rem hsl(207, 25%, 11%, 0.16)',
  'inline-xs-neutral-light-16': 'inset 0 0 0 0.0625rem hsl(207, 25%, 85%, 0.16)',
  'inline-xs-neutral-light-100': 'inset 0 0 0 0.0625rem hsl(207, 25%, 85%, 1)',
}
